<template>
  <div class="w-full sm:pb-0 pb-16">
    <slot name="modals"></slot>

    <ArtworkGridSkeleton class="mt-2.5" v-if="loading" :limit="skeletonLimit" />

    <div v-else-if="items.length > 0">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-1"
      >
        <ArtworkCard
          v-for="item in items"
          :key="item._id"
          :artwork="item"
          :show-user-avatar="showUserAvatar"
          @preview="(art) => artworkActionStore.openPreview(art)"
        >
          <template #actions
            ><slot name="item-actions" :item="item"></slot
          ></template>
          <template #footer
            ><slot name="item-footer" :item="item"></slot
          ></template>
        </ArtworkCard>
      </div>

      <ClientOnly>
        <div v-if="totalPages > 1" class="mt-2.5">
          <BasePagination
            :current-page="currentPage"
            :total-pages="totalPages"
            @change-page="(p) => $emit('change-page', p)"
            @next="$emit('next')"
            @prev="$emit('prev')"
          />
        </div>
      </ClientOnly>
    </div>

    <div v-else class="flex items-center justify-center w-full h-[50vh]">
      <BaseNotFound
        :title="notFoundTitle"
        :label="notFoundLabel"
        :action="action"
        @click="$emit('notFoundAction')"
      >
        <template #icon>
          <Icon name="tabler:palette-filled" size="30" class="text-primary" />
        </template>
      </BaseNotFound>
    </div>
  </div>
</template>

<script setup lang="ts">
const artworkActionStore = useArtworkActionStore();

interface Props {
  items: any[];
  loading: boolean;
  currentPage: number;
  totalPages?: number;
  skeletonLimit?: number;
  notFoundTitle?: string;
  notFoundLabel?: string;
  showUserAvatar?: boolean;
  action?: boolean;
}

withDefaults(defineProps<Props>(), {
  skeletonLimit: 10,
  notFoundTitle: "No artworks found",
  currentPage: 1,
  totalPages: 0,
  showUserAvatar: false,
  action: false,
});

defineEmits(["change-page", "next", "prev", "notFoundAction"]);
</script>
